export enum RequestValidationTypes {
    dermaCscV1AddDraftRequest = 'dermaCscV1AddDraftRequest',
    dermaCscV1AddFinalRequest = 'dermaCscV1AddFinalRequest',
    dermaCscV1EditDraftRequest = 'dermaCscV1EditDraftRequest',
    dermaCscV1EditFinalRequest = 'dermaCscV1EditFinalRequest',
    dermaCV1AddDraftRequest = 'dermaCV1AddDraftRequest',
    dermaCV1AddFinalRequest = 'dermaCV1AddFinalRequest',
    dermaCV1EditDraftRequest = 'dermaCV1EditDraftRequest',
    dermaCV1EditFinalRequest = 'dermaCV1EditFinalRequest',
    dermaCwondV1AddDraftRequest = 'dermaCwondV1AddDraftRequest',
    dermaCwondV1AddFinalRequest = 'dermaCwondV1AddFinalRequest',
    dermaCwondV1EditDraftRequest = 'dermaCwondV1EditDraftRequest',
    dermaCwondV1EditFinalRequest = 'dermaCwondV1EditFinalRequest',
    dermaOthV1AddDraftRequest = 'dermaOthV1AddDraftRequest',
    dermaOthV1AddFinalRequest = 'dermaOthV1AddFinalRequest',
    dermaOthV1EditDraftRequest = 'dermaOthV1EditDraftRequest',
    dermaOthV1EditFinalRequest = 'dermaOthV1EditFinalRequest',
    dermaSnelCscV1AddDraftRequest = 'dermaSnelCscV1AddDraftRequest',
    dermaSnelCscV1AddFinalRequest = 'dermaSnelCscV1AddFinalRequest',
    dermaSnelCscV1EditDraftRequest = 'dermaSnelCscV1EditDraftRequest',
    dermaSnelCscV1EditFinalRequest = 'dermaSnelCscV1EditFinalRequest',
    dermaSnelCV1AddDraftRequest = 'dermaSnelCV1AddDraftRequest',
    dermaSnelCV1AddFinalRequest = 'dermaSnelCV1AddFinalRequest',
    dermaSnelCV1EditDraftRequest = 'dermaSnelCV1EditDraftRequest',
    dermaSnelCV1EditFinalRequest = 'dermaSnelCV1EditFinalRequest',
    ggzbTherV1AddDraftRequest = 'ggzbTherV1AddDraftRequest',
    ggzbTherV1AddFinalRequest = 'ggzbTherV1AddFinalRequest',
    ggzbTherV1EditDraftRequest = 'ggzbTherV1EditDraftRequest',
    ggzbTherV1EditFinalRequest = 'ggzbTherV1EditFinalRequest',
    ggzcf2fV1AddDraftRequest = 'ggzcf2fV1AddDraftRequest',
    ggzcf2fV1AddFinalRequest = 'ggzcf2fV1AddFinalRequest',
    ggzcf2fV1EditDraftRequest = 'ggzcf2fV1EditDraftRequest',
    ggzcf2fV1EditFinalRequest = 'ggzcf2fV1EditFinalRequest',
    ggzcgV1AddDraftRequest = 'ggzcgV1AddDraftRequest',
    ggzcgV1AddFinalRequest = 'ggzcgV1AddFinalRequest',
    ggzcgV1EditDraftRequest = 'ggzcgV1EditDraftRequest',
    ggzcgV1EditFinalRequest = 'ggzcgV1EditFinalRequest',
    ggzcmdoV1AddDraftRequest = 'ggzcmdoV1AddDraftRequest',
    ggzcmdoV1AddFinalRequest = 'ggzcmdoV1AddFinalRequest',
    ggzcmdoV1EditDraftRequest = 'ggzcmdoV1EditDraftRequest',
    ggzcmdoV1EditFinalRequest = 'ggzcmdoV1EditFinalRequest',
    ggzctriageV1AddDraftRequest = 'ggzctriageV1AddDraftRequest',
    ggzctriageV1AddFinalRequest = 'ggzctriageV1AddFinalRequest',
    ggzctriageV1EditDraftRequest = 'ggzctriageV1EditDraftRequest',
    ggzctriageV1EditFinalRequest = 'ggzctriageV1EditFinalRequest',
    ggzctV1AddDraftRequest = 'ggzctV1AddDraftRequest',
    ggzctV1AddFinalRequest = 'ggzctV1AddFinalRequest',
    ggzctV1EditDraftRequest = 'ggzctV1EditDraftRequest',
    ggzctV1EditFinalRequest = 'ggzctV1EditFinalRequest',
    ggzoEmblV1AddDraftRequest = 'ggzoEmblV1AddDraftRequest',
    ggzoEmblV1AddFinalRequest = 'ggzoEmblV1AddFinalRequest',
    ggzoEmblV1EditDraftRequest = 'ggzoEmblV1EditDraftRequest',
    ggzoEmblV1EditFinalRequest = 'ggzoEmblV1EditFinalRequest',
    ggzoIntV1AddDraftRequest = 'ggzoIntV1AddDraftRequest',
    ggzoIntV1AddFinalRequest = 'ggzoIntV1AddFinalRequest',
    ggzoIntV1EditDraftRequest = 'ggzoIntV1EditDraftRequest',
    ggzoIntV1EditFinalRequest = 'ggzoIntV1EditFinalRequest',
    ggzvV1AddDraftRequest = 'ggzvV1AddDraftRequest',
    ggzvV1AddFinalRequest = 'ggzvV1AddFinalRequest',
    ggzvV1EditDraftRequest = 'ggzvV1EditDraftRequest',
    ggzvV1EditFinalRequest = 'ggzvV1EditFinalRequest',
    gtcV1AddDraftRequest = 'gtcV1AddDraftRequest',
    gtcV1AddFinalRequest = 'gtcV1AddFinalRequest',
    gtcV1EditDraftRequest = 'gtcV1EditDraftRequest',
    gtcV1EditFinalRequest = 'gtcV1EditFinalRequest',
    gtoV1AddDraftRequest = 'gtoV1AddDraftRequest',
    gtoV1AddFinalRequest = 'gtoV1AddFinalRequest',
    gtoV1EditDraftRequest = 'gtoV1EditDraftRequest',
    gtoV1EditFinalRequest = 'gtoV1EditFinalRequest',
    orthCV1AddDraftRequest = 'orthCV1AddDraftRequest',
    orthCV1AddFinalRequest = 'orthCV1AddFinalRequest',
    orthCV1EditDraftRequest = 'orthCV1EditDraftRequest',
    orthCV1EditFinalRequest = 'orthCV1EditFinalRequest',
    orthOFolV1AddDraftRequest = 'orthOFolV1AddDraftRequest',
    orthOFolV1AddFinalRequest = 'orthOFolV1AddFinalRequest',
    orthOFolV1EditDraftRequest = 'orthOFolV1EditDraftRequest',
    orthOFolV1EditFinalRequest = 'orthOFolV1EditFinalRequest',
    orthOV1AddDraftRequest = 'orthOV1AddDraftRequest',
    orthOV1AddFinalRequest = 'orthOV1AddFinalRequest',
    orthOV1EditDraftRequest = 'orthOV1EditDraftRequest',
    orthOV1EditFinalRequest = 'orthOV1EditFinalRequest',
    osasendV1AddDraftRequest = 'osasendV1AddDraftRequest',
    osasendV1AddFinalRequest = 'osasendV1AddFinalRequest',
    osasendV1EditDraftRequest = 'osasendV1EditDraftRequest',
    osasendV1EditFinalRequest = 'osasendV1EditFinalRequest',
    osaseV1AddDraftRequest = 'osaseV1AddDraftRequest',
    osaseV1AddFinalRequest = 'osaseV1AddFinalRequest',
    osaseV1EditDraftRequest = 'osaseV1EditDraftRequest',
    osaseV1EditFinalRequest = 'osaseV1EditFinalRequest',
    osaseV2AddDraftRequest = 'osaseV2AddDraftRequest',
    osaseV2AddFinalRequest = 'osaseV2AddFinalRequest',
    osaseV2EditDraftRequest = 'osaseV2EditDraftRequest',
    osaseV2EditFinalRequest = 'osaseV2EditFinalRequest',
    osasnV1AddDraftRequest = 'osasnV1AddDraftRequest',
    osasnV1AddFinalRequest = 'osasnV1AddFinalRequest',
    osasnV1EditDraftRequest = 'osasnV1EditDraftRequest',
    osasnV1EditFinalRequest = 'osasnV1EditFinalRequest',
    osasoV1AddDraftRequest = 'osasoV1AddDraftRequest',
    osasoV1AddFinalRequest = 'osasoV1AddFinalRequest',
    osasoV1EditDraftRequest = 'osasoV1EditDraftRequest',
    osasoV1EditFinalRequest = 'osasoV1EditFinalRequest',
    osasqV1AddDraftRequest = 'osasqV1AddDraftRequest',
    osasqV1AddFinalRequest = 'osasqV1AddFinalRequest',
    osasqV1EditDraftRequest = 'osasqV1EditDraftRequest',
    osasqV1EditFinalRequest = 'osasqV1EditFinalRequest',
    osasvcV1AddDraftRequest = 'osasvcV1AddDraftRequest',
    osasvcV1AddFinalRequest = 'osasvcV1AddFinalRequest',
    osasvcV1EditDraftRequest = 'osasvcV1EditDraftRequest',
    osasvcV1EditFinalRequest = 'osasvcV1EditFinalRequest',
    osasvcV2AddDraftRequest = 'osasvcV2AddDraftRequest',
    osasvcV2AddFinalRequest = 'osasvcV2AddFinalRequest',
    osasvcV2EditDraftRequest = 'osasvcV2EditDraftRequest',
    osasvcV2EditFinalRequest = 'osasvcV2EditFinalRequest',
    osasvoV1AddDraftRequest = 'osasvoV1AddDraftRequest',
    osasvoV1AddFinalRequest = 'osasvoV1AddFinalRequest',
    osasvoV1EditDraftRequest = 'osasvoV1EditDraftRequest',
    osasvoV1EditFinalRequest = 'osasvoV1EditFinalRequest',
    osasvV1AddDraftReferralSmall = 'osasvV1AddDraftReferralSmall',
    osasvV1AddFinalReferralSmall = 'osasvV1AddFinalReferralSmall',
    osasvV1EditDraftReferralSmall = 'osasvV1EditDraftReferralSmall',
    osasvV1EditFinalReferralSmall = 'osasvV1EditFinalReferralSmall',
    pilotConsultationV1AddDraftRequest = 'pilotConsultationV1AddDraftRequest',
    pilotConsultationV1AddFinalRequest = 'pilotConsultationV1AddFinalRequest',
    pilotConsultationV1EditDraftRequest = 'pilotConsultationV1EditDraftRequest',
    pilotConsultationV1EditFinalRequest = 'pilotConsultationV1EditFinalRequest',
    pilotContactV1AddRequest = 'contactV1AddDraftRequest',
    pilotContactV1EditRequest = 'contactV1EditFinalRequest',
    pilotExaminationV1AddDraftRequest = 'pilotExaminationV1AddDraftRequest',
    pilotExaminationV1AddFinalRequest = 'pilotExaminationV1AddFinalRequest',
    pilotExaminationV1EditDraftRequest = 'pilotExaminationV1EditDraftRequest',
    pilotExaminationV1EditFinalRequest = 'pilotExaminationV1EditFinalRequest',
    pilotReferralSmallV1AddDraftRequest = 'pilotReferralSmallV1AddDraftRequest',
    pilotReferralSmallV1AddFinalRequest = 'pilotReferralSmallV1AddFinalRequest',
    pilotReferralSmallV1EditDraftRequest = 'pilotReferralSmallV1EditDraftRequest',
    pilotReferralSmallV1EditFinalRequest = 'pilotReferralSmallV1EditFinalRequest',
    pilotReferralV1AddDraftRequest = 'pilotReferralV1AddDraftRequest',
    pilotReferralV1AddFinalRequest = 'pilotReferralV1AddFinalRequest',
    pilotReferralV1EditDraftRequest = 'pilotReferralV1EditDraftRequest',
    pilotReferralV1EditFinalRequest = 'pilotReferralV1EditFinalRequest',
    tcchV1AddDraftRequest = 'tcchV1AddDraftRequest',
    tcchV1AddFinalRequest = 'tcchV1AddFinalRequest',
    tcchV1EditDraftRequest = 'tcchV1EditDraftRequest',
    tcchV1EditFinalRequest = 'tcchV1EditFinalRequest',
    tcciV1AddDraftRequest = 'tcciV1AddDraftRequest',
    tcciV1AddFinalRequest = 'tcciV1AddFinalRequest',
    tcciV1EditDraftRequest = 'tcciV1EditDraftRequest',
    tcciV1EditFinalRequest = 'tcciV1EditFinalRequest',
    tccrV1AddDraftRequest = 'tccrV1AddDraftRequest',
    tccrV1AddFinalRequest = 'tccrV1AddFinalRequest',
    tccrV1EditDraftRequest = 'tccrV1EditDraftRequest',
    tccrV1EditFinalRequest = 'tccrV1EditFinalRequest',
    tcohV1AddDraftRequest = 'tcohV1AddDraftRequest',
    tcohV1AddFinalRequest = 'tcohV1AddFinalRequest',
    tcohV1EditDraftRequest = 'tcohV1EditDraftRequest',
    tcohV1EditFinalRequest = 'tcohV1EditFinalRequest',
    tcohV2AddDraftRequest = 'tcohV2AddDraftRequest',
    tcohV2AddFinalRequest = 'tcohV2AddFinalRequest',
    tcohV2EditDraftRequest = 'tcohV2EditDraftRequest',
    tcohV2EditFinalRequest = 'tcohV2EditFinalRequest',
    tcorV1AddDraftRequest = 'tcorV1AddDraftRequest',
    tcorV1AddFinalRequest = 'tcorV1AddFinalRequest',
    tcorV1EditDraftRequest = 'tcorV1EditDraftRequest',
    tcorV1EditFinalRequest = 'tcorV1EditFinalRequest',
    tfcV1AddDraftRequest = 'tfcV1AddDraftRequest',
    tfcV1AddFinalRequest = 'tfcV1AddFinalRequest',
    tfcV1EditDraftRequest = 'tfcV1EditDraftRequest',
    tfcV1EditFinalRequest = 'tfcV1EditFinalRequest',
    tfoV1AddDraftRequest = 'tfoV1AddDraftRequest',
    tfoV1AddFinalRequest = 'tfoV1AddFinalRequest',
    tfoV1EditDraftRequest = 'tfoV1EditDraftRequest',
    tfoV1EditFinalRequest = 'tfoV1EditFinalRequest',
    tiecgV1AddDraftRequest = 'tiecgV1AddDraftRequest',
    tiecgV1AddFinalRequest = 'tiecgV1AddFinalRequest',
    tiecgV1EditDraftRequest = 'tiecgV1EditDraftRequest',
    tiecgV1EditFinalRequest = 'tiecgV1EditFinalRequest',
    tocV1AddDraftRequest = 'tocV1AddDraftRequest',
    tocV1AddFinalRequest = 'tocV1AddFinalRequest',
    tocV1EditDraftRequest = 'tocV1EditDraftRequest',
    tocV1EditFinalRequest = 'tocV1EditFinalRequest',
    tooV1AddDraftRequest = 'tooV1AddDraftRequest',
    tooV1AddFinalRequest = 'tooV1AddFinalRequest',
    tooV1EditDraftRequest = 'tooV1EditDraftRequest',
    tooV1EditFinalRequest = 'tooV1EditFinalRequest',
    tovV1AddDraftRequest = 'tovV1AddDraftRequest',
    tovV1AddFinalRequest = 'tovV1AddFinalRequest',
    tovV1EditDraftRequest = 'tovV1EditDraftRequest',
    tovV1EditFinalRequest = 'tovV1EditFinalRequest',
    tpcV1AddDraftRequest = 'tpcV1AddDraftRequest',
    tpcV1AddFinalRequest = 'tpcV1AddFinalRequest',
    tpcV1EditDraftRequest = 'tpcV1EditDraftRequest',
    tpcV1EditFinalRequest = 'tpcV1EditFinalRequest',
    tpoV1AddDraftRequest = 'tpoV1AddDraftRequest',
    tpoV1AddFinalRequest = 'tpoV1AddFinalRequest',
    tpoV1EditDraftRequest = 'tpoV1EditDraftRequest',
    tpoV1EditFinalRequest = 'tpoV1EditFinalRequest',
}
